const toogleSubNav = () => {
    const sectionSubNav = document.querySelector(".section-sub-nav");

    if (sectionSubNav) {
        const itemNav = sectionSubNav.querySelector(".navigation .title");
        const buttonSubNav = sectionSubNav.querySelector(".navigation .title .button-collapse");
        const dropdownList = sectionSubNav.querySelector(".dropdown-list-wrapper");

        let hoverTimeout;

        itemNav.addEventListener("click", event => {
            event.stopPropagation();
            const isActive = dropdownList.classList.contains("active");

            if (isActive) {
                dropdownList.classList.remove("active");
                buttonSubNav.classList.remove("button-collapse-active");
            } else {
                dropdownList.classList.add("active");
                buttonSubNav.classList.add("button-collapse-active");
            }
        });

        const listItems = sectionSubNav.querySelectorAll(".dropdown-list > li");

        listItems.forEach(listItem => {
            const buttonItemCollapse = listItem.querySelector(".button-collapse");
            const subNavItem = listItem.querySelector(".sub-nav-items");
            const items = listItem.querySelector(".item-collapse");

            if (buttonItemCollapse) {
                // *** Desktop***
                listItem.addEventListener("mouseenter", () => {
                    if (window.innerWidth > 1024) {
                        clearTimeout(hoverTimeout);
                        subNavItem.classList.add("hoverActive");
                        buttonItemCollapse.classList.add("button-collapse-active");
                        items.classList.add("active-item");

                        listItems.forEach(otherItem => {
                            if (otherItem !== listItem) {
                                const otherSubNavItem = otherItem.querySelector(".sub-nav-items");
                                const otherButtonCollapse = otherItem.querySelector(".button-collapse");
                                const otherItems = otherItem.querySelector(".item-collapse");

                                if (otherSubNavItem) {
                                    otherSubNavItem.classList.remove("hoverActive");
                                    otherButtonCollapse.classList.remove("button-collapse-active");
                                    otherItems.classList.remove("active-item");
                                }
                            }
                        });
                    }
                });

                // *** Desktop ***
                listItem.addEventListener("mouseleave", () => {
                    if (window.innerWidth > 1024) {
                        hoverTimeout = setTimeout(() => {
                            subNavItem.classList.remove("hoverActive");
                            buttonItemCollapse.classList.remove("button-collapse-active");
                            items.classList.remove("active-item");
                        }, 1000);
                    }
                });

                // *** Mobile ***
                listItem.addEventListener("click", event => {
                    if (window.innerWidth <= 1024) {
                        event.stopPropagation();
                        const isActive = subNavItem.classList.contains("hoverActive");

                        if (isActive) {
                            subNavItem.classList.remove("hoverActive");
                            buttonItemCollapse.classList.remove("button-collapse-active");
                            items.classList.remove("active-item");
                        } else {
                            listItems.forEach(otherItem => {
                                const otherSubNavItem = otherItem.querySelector(".sub-nav-items");
                                const otherButtonCollapse = otherItem.querySelector(".button-collapse");
                                const otherItems = otherItem.querySelector(".item-collapse");

                                if (otherSubNavItem) {
                                    otherSubNavItem.classList.remove("hoverActive");
                                    otherButtonCollapse.classList.remove("button-collapse-active");
                                    otherItems.classList.remove("active-item");
                                }
                            });

                            subNavItem.classList.add("hoverActive");
                            buttonItemCollapse.classList.add("button-collapse-active");
                            items.classList.add("active-item");
                        }
                    }
                });
            }
        });

        // *** Close click anything else ***
        document.addEventListener("click", event => {
            if (!sectionSubNav.contains(event.target)) {
                dropdownList.classList.remove("active");
                buttonSubNav.classList.remove("button-collapse-active");

                listItems.forEach(listItem => {
                    const subNavItem = listItem.querySelector(".sub-nav-items");
                    const buttonItemCollapse = listItem.querySelector(".button-collapse");
                    const items = listItem.querySelector(".item-collapse");

                    if (subNavItem) {
                        subNavItem.classList.remove("hoverActive");
                        buttonItemCollapse.classList.remove("button-collapse-active");
                        items.classList.remove("active-item");
                    }
                });
            }
        });
    }
};

function init() {
    toogleSubNav();
}

export default { init };
